// extracted by mini-css-extract-plugin
export default {"block":"block___x9thR","emptyBody":"emptyBody___nKCu6","emptyTip":"emptyTip___vQVn0","outlineBtn":"outlineBtn___jcKKx","aboutPanel":"aboutPanel___VP1jD"};